import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import EditSchoolPerformanceForm from "../../components/EditSchoolPerformanceForm/EditSchoolPerformanceForm";
import Layout from "../../components/shared/Layout/Layout";

const EditSchoolPerformancePage = ({ grades, getGradeList, mark }) => {
  useEffect(() => {
    getGradeList();
  }, [getGradeList]);
  return (
    <div className="bg_light">
      <Layout title={`Edit School Performance`}>
        {grades ? (
          <EditSchoolPerformanceForm edit={true} grades={grades} mark={mark} />
        ) : (
          <h3>Loading...</h3>
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(EditSchoolPerformancePage);
